/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './ProOnboard.css';
import WhereField from './partials/WhereField';
import LeaderboardStats from './partials/LeaderboardStats';
import RegisterForm from './partials/RegisterForm';
import CompanySignUpForm from './partials/CompanySignUpForm';
import OmniField from './partials/OmniField';
import Loading from './partials/Loading';

import {
  register,
  fetchUser,
  companySignUp,
} from '../actions';


class ProOnboard extends OzComponent {

  static need = [
    ['user', fetchUser],
  ]

  state = {};

  createCompany(e, values) {
    console.log('create company', values);
    this.props.companySignUp(values)
      .then(resp => {
        if (resp.error) return;
        console.log('create company', resp);
        setToken(resp.token);
        this.props.fetchUser()
          .then(resp => {
            console.log('fetch user resp', resp);
            navTo('/pro/rooms');
          });
      });
  }

  handleResult(result) {
    console.log('omni gave result', result);
    this.setState({
      company: result.company,
      cityName: result.cityName,
      locationId: result.id,
    })
  }

  renderFindCompany() {
    if (this.state.locationId) return;
    if (this.state.createNew) return;

    let cantFindNode = (
      <div className="cant-find">
        <Button bsSize="small" onClick={() => this.setState({ createNew: true })}>Can't find my company</Button>
      </div>
    );

    return (
      <div>
        <div className="search">
          <OmniField
            beforeResults={cantFindNode}
            showTypes={['locations']}
            prefill="Find your company"
            onResult={r => this.handleResult(r)}
          />
        </div>
      </div>
    );
  }

  renderCreateNew() {
    if (!this.state.locationId && !this.state.createNew) return;

    return (
      <div>
        <div className="header">
          {this.state.locationId ? 'Claim your listing' : 'Create new company'}
        </div>
        <CompanySignUpForm
          locationId={this.state.locationId}
          errors={this.props.errors.companySignUp}
          values={{}}
          onSubmit={(e, values) => this.createCompany(e, values)}
          buttonText="Sign Up"
          user={this.props.user}
        />
      </div>
    );
  }

  renderBody() {
    let user = this.props.user;
    if (!user) return <Loading center />;

    if (user && user.profile && user.profile.companies && user.profile.companies.length > 0) {
      let company = user.profile.companies[0];
      return (
        <div>
          <p>You are logged in as <b>{company.name}</b></p>
          <div className="center">
            <Link to="/pro/rooms"><Button bsStyle="primary" bsSize="large">Go to Dashboard</Button></Link>
          </div>
        </div>
      );
    }

    return (
      <div>
        <p><b>To get started, create a company profile.</b></p>
        <p>We might already have your company name on record, but if not, we can make a new one.
        </p>
        {this.renderFindCompany()}
        {this.renderCreateNew()}
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="ProOnboard" title="Pro Account">
        {this.renderBody()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    register,
    fetchUser,
    companySignUp,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProOnboard);



/** WEBPACK FOOTER **
 ** ./src/components/ProOnboard.js
 **/